var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.12978L22.8417 10.9401L22.958 11.1759L23.2182 11.2137L34.0445 12.7868L26.2105 20.4231L26.0223 20.6066L26.0667 20.8657L27.9161 31.6483L18.2327 26.5574L18 26.4351L17.7673 26.5574L8.08393 31.6483L9.9333 20.8657L9.97773 20.6066L9.7895 20.4231L1.95546 12.7868L12.7818 11.2137L13.042 11.1759L13.1583 10.9401L18 1.12978Z",
    fill: "url(#paint0_linear_1717_888)",
    stroke: "#FF9D0A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1717_888",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7CF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A400"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledStar);
export default __webpack_public_path__ + "static/media/filledStar.68f96fe4d86af9116ed6dd84b2de186c.svg";
export { ForwardRef as ReactComponent };